import { z } from "zod";

export const CustomProductFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, { message: "CUSTOM_ITEM_NAME_VALIDATION_SHORT" }),
});
